import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
/**
 * ReceiptTitle wrapper
 */
export const receiptTitleWrapperStyles = ({ theme }) => css `
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: ${pxToRem(theme.spacing['200'])};
`;
export const StyledReceiptTitleWrapper = styled.div `
	${receiptTitleWrapperStyles}
`;
/**
 * ReceiptTitle
 */
export const receiptTitleStyles = ({ theme }) => css `
	flex: 1;
	margin: 0;
	color: ${theme.colors.base.textTitles};
`;
export const StyledReceiptTitle = styled(Typography).attrs({
    variant: 'component-title',
    tagName: 'h2',
}) `
	${receiptTitleStyles}
`;
/**
 * ReceiptTitle close button
 */
export const receiptTitleCloseButtonStyles = ({ theme }) => css `
	padding: 0;
	width: auto;
	border: none;
	cursor: pointer;
	color: unset;
	line-height: inherit; /* use line height of title to align button with first line of text */
	background-color: ${theme.colors.light.bgReceiptPrice};

	&,
	&:hover,
	&:active,
	&:focus {
		color: ${theme.colors.highlight.iconInteractive};
	}
`;
export const StyledReceiptTitleCloseButton = styled.button `
	${receiptTitleCloseButtonStyles}
`;
